import secondaryComponents from "../..";
import { usePOItemsTable } from "./usePOItemsTable";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../assets/svgImages";

export const POItemsTable = ({ POItems = [], PODetails = null }) => {
  const { instance } = usePOItemsTable({
    POItems,
    PODetails,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div>
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={styles.pOItemsTable}
        >
          <div className="pt-5 text-center">
            <PurchaseOrderImage />
            <h4>You have no Purchase Order</h4>
          </div>
        </secondaryComponents.TableHelper>
      </div>
    </>
  );
};
